import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  PlantModelElement,
  PlantGroupElement,
} from '../models/O3AdministrationModels/plant-model';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class DefectDashBoardService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  getUsers(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Dashboard/GetUserListForEG', data);
  }

  getDefectDashboard(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'NewDefectDashBoard/GetDashBoardReporData', data);
  }

}